import { CSS_CERTIFIED } from '@/constants';

export const cssCertifiedFormatter = (params: any) => {
  const value = params.value;
  return (
    Object.entries(CSS_CERTIFIED).find(([key, val]) => val === value)?.[0] ?? ''
  );
};
